import React, { useState } from 'react';
import { useOutreach } from '../context/OutreachContext';
import ProspectInbox from '../components/outreach/ProspectInbox';
import OutreachQueue from '../components/outreach/OutreachQueue';
import MicrositeBuilder from '../components/outreach/MicrositeBuilder';
import TrackingDashboard from '../components/outreach/TrackingDashboard';
import AddProspectModal from '../components/outreach/AddProspectModal';
import ImportProspectsModal from '../components/outreach/ImportProspectsModal';
import SafeIcon from '../common/SafeIcon';

const OutreachDashboard = () => {
  const [activeTab, setActiveTab] = useState('queue');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const { checkGuardrails } = useOutreach();

  // Guardrails check
  const guard = checkGuardrails ? checkGuardrails() : { warning: false };

  const menuItems = [
    { id: 'queue', label: 'Dagens Outreach (V1)', icon: '⚡' },
    { id: 'inbox', label: 'Prospect Inbox', icon: '📋' },
    { id: 'sites', label: 'Microsite Builder / V2 – ikke aktivert', icon: '🌐' },
    { id: 'tracking', label: 'Tracking & Analyse', icon: '📊' },
  ];

  return (
    <div className="p-8 max-w-[1800px] mx-auto min-h-screen space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center border-b border-slate-200 pb-6">
        <div>
          <h1 className="text-3xl font-black text-slate-900 tracking-tight">Outreach Center</h1>
          <p className="text-slate-500 font-medium">Manuell prospektering og kampanjesporing.</p>
        </div>
        <div className="flex items-center gap-3">
          <button onClick={() => setIsImportModalOpen(true)} className="flex items-center gap-2 px-5 py-3 bg-white text-slate-700 border border-slate-200 rounded-xl font-bold hover:bg-slate-50 transition-all">
            <SafeIcon icon="📥" className="w-4 h-4" /> Importer Prospekter
          </button>
          <button onClick={() => setIsModalOpen(true)} className="flex items-center gap-2 px-6 py-3 bg-slate-900 text-white rounded-xl font-bold hover:bg-slate-800 transition-all shadow-lg">
            <SafeIcon icon="➕" className="w-4 h-4" /> Nytt Prospekt
          </button>
        </div>
      </div>

      {/* Guardrail Warning */}
      {guard.warning && (
        <div className="p-4 bg-amber-50 border border-amber-200 rounded-xl flex items-center gap-3 text-amber-800 font-bold text-sm">
          <SafeIcon icon="⚠️" className="w-5 h-5" />
          {guard.message}
        </div>
      )}

      {/* Navigation */}
      <div className="flex gap-2 overflow-x-auto pb-2">
        {menuItems.map(item => (
          <button 
            key={item.id} 
            onClick={() => setActiveTab(item.id)}
            className={`px-6 py-3 rounded-xl text-xs font-black uppercase tracking-widest transition-all flex items-center gap-2 whitespace-nowrap ${activeTab === item.id ? 'bg-primary-600 text-white shadow-lg' : 'bg-white text-slate-500 hover:bg-slate-50'}`}
          >
            <SafeIcon icon={item.icon} className="w-4 h-4" />
            {item.label}
          </button>
        ))}
      </div>

      {/* Content Area */}
      <div className="animate-in fade-in slide-in-from-bottom-4 duration-500 min-h-[500px]">
        {activeTab === 'queue' && <OutreachQueue />}
        {activeTab === 'inbox' && <ProspectInbox />}
        {activeTab === 'sites' && <MicrositeBuilder />}
        {activeTab === 'tracking' && <TrackingDashboard />}
      </div>

      {/* Info Footer */}
      <div className="mt-12 p-4 bg-blue-50 border border-blue-100 rounded-xl text-xs text-blue-800 flex gap-3 items-start">
        <SafeIcon icon="ℹ️" className="w-5 h-5 flex-shrink-0" />
        <div>
          <p className="font-bold mb-1">Safe Mode & LinkedIn Regler</p>
          <p>Systemet scraper ikke LinkedIn og sender ikke meldinger automatisk. LinkedIn Outreach er operativ manuell outreach, hvor systemet hjelper med søk, tekst og oppfølging. All sending skjer av deg personlig.</p>
        </div>
      </div>

      <AddProspectModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <ImportProspectsModal isOpen={isImportModalOpen} onClose={() => setIsImportModalOpen(false)} />
    </div>
  );
};

export default OutreachDashboard;